import { create } from 'zustand';
import { login as apiLogin, getProfile } from '../api/auth';

const useAuthStore = create((set) => ({
    user:    null,
    loading: false,
    error:   null,

    login: async (credentials) => {
        set({ loading: true, error: null });
        try {
            const { data } = await apiLogin(credentials);
            localStorage.setItem('access_token',  data.access);
            localStorage.setItem('refresh_token', data.refresh);
            const profile = await getProfile();
            set({ user: profile.data, loading: false });
            return true;
        } catch (err) {
            set({
                error:   err.response?.data?.detail || 'Identifiants incorrects.',
                loading: false
            });
            return false;
        }
    },

    logout: () => {
        localStorage.clear();
        set({ user: null });
    },

    fetchProfile: async () => {
        try {
            const { data } = await getProfile();
            set({ user: data });
        } catch {
            localStorage.clear();
            set({ user: null });
        }
    },
}));

export default useAuthStore;